<template>
    <CRow>
        <CCol col="12" lg="12">
            <CCard>
                <CCardBody>
                    <form
                        @submit.prevent="createRecord('CHARGES', {name:name})"
                        method="post"
                    >
                        <h3 v-if="isEditing">
                            {{ $t('button.edit') }} {{ $t('charges.title') }}
                        </h3>
                        <h3 v-else>{{ $t('button.create') }} {{ $t('charges.title') }}</h3>
                        <br>
                        <CRow>
                            <CCol col="6" lg="6">
                                <CRow>
                                    <CCol col="10" lg="10">
                                        <CInput 
                                            :placeholder="$t('typeVehicles.placeholder')" 
                                            :label="$t('typeVehicles.title')" 
                                            v-model="field.type_vehicle_id" 
                                            type="text" 
                                            required
                                            readonly
                                        ></CInput>
                                    </CCol>
                                    <CCol col="2" lg="2" style="margin-top:20px">
                                        <CButton color="warning" class="m-2" @click="showDetail = true">
                                            <CIcon :content="updateIcon" /> {{ $t('button.options') }}
                                        </CButton>
                                    </CCol>
                                </CRow>
                            </CCol>
                            <CCol col="6" lg="6">
                                <CInput 
                                    :placeholder="$t('fields.name.placeholder')" 
                                    :label="$t('fields.name.label')" 
                                    v-model="name" 
                                    type="text" 
                                    required
                                ></CInput>
                            </CCol>
                            <CCol col="6" lg="6">
                                <CInput 
                                    :placeholder="$t('fields.name.placeholder')" 
                                    :label="$t('fields.name.label')" 
                                    v-model="name" 
                                    type="text" 
                                    required
                                ></CInput>
                            </CCol>
                            <CCol col="6" lg="6">
                                <CInput 
                                    :placeholder="$t('fields.name.placeholder')" 
                                    :label="$t('fields.name.label')" 
                                    v-model="name" 
                                    type="text" 
                                    required
                                ></CInput>
                            </CCol>
                       </CRow>
                        <CRow>
                            <CCol col="12" lg="12" class="text-right">
                                <CButton color="success" type="submit" class="m-2">
                                    <template v-if="isEditing">
                                        <CIcon :content="updateIcon" /> {{ $t('button.update') }}
                                    </template>
                                    <template v-else>
                                        <CIcon :content="addIcon" /> {{ $t('button.create') }}
                                    </template>
                                </CButton>
                                <CButton color="primary" to="/categories" class="m-2">
                                    <CIcon :content="backIcon" /> {{ $t('button.back') }}
                                </CButton>
                            </CCol>
                        </CRow>
                    </form>
                </CCardBody>
            </CCard>
        </CCol>
        <CModal
            color="warning"
            :show.sync="showDetail"
            :title="$t('typeVehicles.title')"
        >
            <div>
                <CRow v-for="typeVehicle in typeVehicles" :key="typeVehicle.id">
                    <div class="col-sm-12">
                        <label class="label-detail">
                            {{typeVehicle.name}}
                        </label>
                    </div>
                </CRow>
            </div>
        </CModal>
    </CRow>
</template>

<script>
import axios from 'axios'
import catalog from '../../hooks/catalogs';
import { cilSync, cilPlus, cilArrowLeft } from '@coreui/icons';

export default {
    name: 'CategoryCreate',
    mixins: [catalog],
    data() {
        return {
            updateIcon: cilSync,
            addIcon: cilPlus,
            backIcon: cilArrowLeft,
            name: null,
            states: [],
            typeVehicles: [],
            showDetail: false,
            field: {
                type_id: '',
                state_id: '',
                type_vehicle_id: '',
            },
        }
    },
    methods: {
        onSelectTipeVehicleSize(vehicleTypeSizeId) {
            console.log("ouaoeu");
        }
    },
    async mounted() {
        let self = this;

        if (this.isEditing) {
            axios.get(`api/charges/${this.$route.params.id}`)
                .then(response => {
                    self.name = response.data.data.name;
                }).catch(error => {
                    if (error.response.status === 401) {
                        self.$router.push({ path: '/login' });
                    } else {
                        self.$toast.error(error.response.data.message);
                    }
                });
        }

        axios.get(`type-vehicle`)
            .then(response => {
                response.data.forEach(function(record){
                    self.typeVehicles = record;
                    console.log(self.typeVehicles);
                });
            }).catch(error => {
                if (error.response.status === 401) {
                    self.$router.push({ path: '/login' });
                } else {
                    self.$toast.error(error.response.data.message);
                }
            });

        axios.get(`states`)
            .then(response => {
                response.data.forEach(function(record){
                    self.states.push({
                        value: record.id,
                        label: record.name,
                    });
                });
            }).catch(error => {
                if (error.response.status === 401) {
                    self.$router.push({ path: '/login' });
                } else {
                    self.$toast.error(error.response.data.message);
                }
            });
    }
}
</script>
